module.exports = __webpack_public_path__ + "19e28268a6be1d343fbc4bb1cbcd301b.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-actoneventures.png
// module id = 626
// module chunks = 0